<!-- 发票信息 -->
<template>
  <div>
    <base-form
      v-model="formData"
      :options="options"
      ref="topData"
      :rules="rules"
      :disabled="!canEdit"
      @input="handleChange"
      label-width="100px"
    >
    </base-form>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import BaseForm from '@/components/form/base-form';
  import API from '@/api/financeCenter/saleInvoice.js';
  import BASE_API from '@/api/dataBase';

  export default {
    name: 'invoiceInfo',
    components: {
      BaseForm,
    },
    props: {
      currencyList: {
        type: Array,
        default: () => [],
      },
      canEdit: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      options() {
        // const data = this.formData;
        return [
          {
            type: 'select',
            label: this.$t('financeSalesInvoice.column.invoiceCompanyName'),
            prop: 'invoiceCompanyCode',
            clearable: true,
            disabled: this.formData.invoiceSource != '3',
            valueType: 'object',
            options: this.companyList,
            required: true,
          }, //公司名称
          {
            type: 'select',
            options: this.departmentList,
            label: '部门',
            prop: 'invoiceDepartmentNo',
            clearable: true,
            disabled: this.$route.query.source == 'receive',
            required: true,
          }, //申请单部门代码
          {
            type: 'input',
            label: this.$t('financeSalesInvoice.column.invoiceNum'),
            prop: 'invoiceNum',
            clearable: true,
            disabled: true,
          }, //单据编号
          {
            type: 'input',
            label: this.$t('financeSalesInvoice.column.invoiceCreatePersonName'),
            prop: 'invoiceCreatePersonName',
            clearable: true,
            disabled: true,
            required: true,
          }, //制单人
          {
            prop: 'businessType',
            label: '业务类别',
            type: 'select',
            clearable: false,
            options: this.dictListMap?.businessCategory,
            required: true,
          },
          {
            type: 'searchTable',
            label: '负责人',
            prop: 'chargePersonNo',
            clearable: true,
            isMultiple: true,
            required: false,
            disabled: false,
            searchType: 'personnel',
            currentValue: this.formData.chargePersonName,
            name: 'chargePersonName',
            code: 'chargePersonNo',
            getName: 'personName',
            getCode: 'personNo',
          }, //负责人
          {
            type: 'date',
            label: this.$t('financeSalesInvoice.column.invoiceCreateDate'),
            prop: 'invoiceCreateDate',
            clearable: true,
            disabled: true,
            required: true,
          }, //制单日期
          {
            type: 'searchTable',
            label: '客户名称',
            prop: 'partnerCode',
            clearable: true,
            isMultiple: true,
            required: true,
            disabled: this.formData.invoiceSource != '3',
            searchType: 'customer',
            extraData: {
              companyCode: this.formData.invoiceCompanyCode
                ? this.formData.invoiceCompanyCode
                : this.userInfo.companyCode,
              departmentCode: this.formData.invoiceDepartmentNo
                ? this.formData.invoiceDepartmentNo
                : this.userInfo.departmentCode,
              requestStatus: 'ZT03',
            },
            currentValue: this.formData.partnerName,
            // name: 'partnerName',
            // code: 'partnerCode',
            // getName: 'partnerZhName',
            // getCode: 'partnerCode',
          }, //客户名称
          {
            type: 'select',
            label: this.$t('financeSalesInvoice.column.currency'),
            prop: 'currency',
            clearable: true,
            options: this.currencyList,
            disabled: ['1', '2'].includes(this.formData.invoiceSource),
            name: 'currencyName',
            code: 'currency',
            valueKey: 'value',
            labelKey: 'label',
            valueType: 'object',
            required: true,
          }, //币种
          {
            type: 'dict',
            label: this.$t('financeSalesInvoice.column.exchangeType'),
            prop: 'exchangeType',
            clearable: true,
            dictType: 'exchange_type',
            disabled: ['1', '2'].includes(this.formData.invoiceSource),
            required: true,
            moreInput: true,
            ruleType: 'object',
            validatorKey: this.formData.exchangeRate,
            moreProp: 'exchangeRate',
            morePlaceholder: this.$t('financeSalesInvoice.placeholder.exchangeRate'),
            moreClearable: true,
            moreRequired: true,
            moreDisabled: this.formData.exchangeType == 'Cooperate',
          }, //汇率类型 //汇率
          {
            type: 'date',
            label: this.$t('financeSalesInvoice.column.exchangeDate'),
            prop: 'exchangeDate',
            clearable: true,
            disabled: false,
            required: true,
          }, //汇率日期
          {
            type: 'date',
            label: this.$t('financeSalesInvoice.column.belongDate'),
            prop: 'belongDate',
            clearable: true,
            disabled: false,
            required: true,
          }, //归属日期
          {
            type: 'dict',
            label: '发票类型',
            prop: 'invoiceType',
            clearable: true,
            dictType: 'invoice_type',
            disabled: this.formData.invoiceSource != '3',
            required: true,
          }, //发票类型
          ...(this.isShowCreditMemo
            ? [
                {
                  type: 'searchTable',
                  label: '关联蓝票',
                  prop: 'invoiceInfoId',
                  clearable: true,
                  isMultiple: true,
                  required: true,
                  searchType: 'blueTicketTable',
                  extraData: {
                    companyCode: this.formData.invoiceCompanyCode,
                    issueStatus: '3',
                    invoiceType: 'invoice',
                    partnerCodes: [this.formData.partnerCode],
                  },
                  currentValue: this.formData.goldenInvoiceNumber,
                  checkRowKeys: [this.formData.invoiceInfoId ? this.formData.invoiceInfoId : null],
                },
                {
                  type: 'select',
                  label: '冲红原因',
                  prop: 'redCause',
                  options: this.dictListMap?.redCauseList || [],
                  required: true,
                },
              ]
            : []),

          {
            type: 'dict',
            label: this.$t('financeSalesInvoice.column.invoiceStatus'),
            prop: 'invoiceStatus',
            clearable: true,
            dictType: 'invoice_status',
            disabled: true,
          }, //单据状态

          {
            type: 'input',
            label: '开票申请总金额',
            prop: 'invoiceAmount',
            clearable: true,
            disabled: true,
          }, //发票含税总金额
          {
            type: 'input',
            label: '税额',
            prop: 'taxAmount',
            clearable: true,
            disabled: true,
          }, //税额
          {
            type: 'input',
            label: '不含税金额',
            prop: 'excludedTaxAmount',
            clearable: true,
            disabled: true,
          }, //不含税金额
          // {
          //   type: 'amountNumber',
          //   label: this.$t('financeSalesInvoice.column.ladingDifferenceAmount'),
          //   prop: 'ladingDifferenceAmount',
          //   clearable: true,
          //   disabled: true,
          // }, //与合同差异金额合计
          {
            type: 'dict',
            label: this.$t('financeSalesInvoice.column.issueType'),
            prop: 'issueStatus',
            clearable: true,
            dictType: 'invoiceIssueStatus',
            disabled: true,
          }, //开票状态
          {
            type: 'input',
            label: '本币总金额',
            prop: 'invoiceAccountedAmount',
            clearable: true,
            disabled: true,
          }, //本币总含税金额
          {
            type: 'input',
            label: '本币税额',
            prop: 'taxAccountedAmount',
            clearable: true,
            disabled: true,
          }, //本币税额
          {
            type: 'input',
            label: '本币不含税金额',
            prop: 'excludedTaxAccountedAmount',
            clearable: true,
            disabled: true,
          }, //本币不含税金额
          // {
          //   type: 'amountNumber',
          //   label: this.$t('financeSalesInvoice.column.recoverableTaxAmount'),
          //   prop: 'recoverableTaxAmount',
          //   clearable: true,
          //   disabled: true,
          // }, //合计出口退税额
          {
            type: 'input',
            label: this.$t('financeSalesInvoice.column.performancePeriod'),
            prop: 'day',
            clearable: true,
            disabled: true,
          }, //天数
          {
            type: 'select',
            label: '费用类型',
            prop: 'expenseTypeCode',
            clearable: true,
            required: true,
            options: [
              { label: '结算开票(货款)', value: '01' },
              { label: '非结算开票', value: '02' },
            ],
          }, //费用类型
          {
            type: 'input',
            label: this.$t('financeSalesInvoice.column.ticketPoint'),
            prop: 'ticketPoint',
            clearable: true,
          }, //票点
          // {
          //   type: 'dict',
          //   dictType: 'tax_class',
          //   label: '税收分类',
          //   prop: 'taxRateCode',
          //   clearable: true,
          //   required: true,
          // }, //税收分类
          {
            type: 'select',
            label: '商品类型',
            prop: 'productType',
            clearable: true,
            options: [
              { label: '开票项', value: '1' },
              { label: '物料', value: '2' },
              { label: '费用项目', value: '3' },
            ],
            required: true,
          }, //税收分类
          {
            type: 'textarea',
            span: 24,
            label: this.$t('financeSalesInvoice.column.mark'),
            prop: 'mark',
            maxlength: 230,
            clearable: true,
            disabled: false,
          }, //备注
        ];
      },
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      rules() {
        return {};
      },
    },
    watch: {
      baseDataRules: function () {
        this.$nextTick(() => {
          this.$refs.baseData.clearValidate();
        });
      },
      // 币种变化
      'formData.currency': {
        handler() {
          this.$emit('updateInvoice', this.formData);
        },
        deep: true,
      },
      //归属日期变化
      'formData.belongDate': {
        handler() {
          this.$emit('updateInvoice', this.formData);
        },
        deep: true,
      },
      // 汇率变化
      'formData.exchangeRate': {
        handler() {
          this.$emit('updateInvoice', this.formData);
        },
        deep: true,
      },
      'formData.businessType': {
        handler(val) {
          if (val == '02') {
            this.formData.productType = '3';
          }
          if (val == '01') {
            this.formData.productType = '2';
          }
        },
        deep: true,
      },
      // 计算本币
      formData() {},
    },
    data() {
      return {
        formData: {
          id: '',
          ledgerCode: '', // 账套
          invoiceSource: '', // 1销售提单,2销售退货,3手写,4服务类合同
          invoiceCompanyCode: '', // 公司代码
          invoiceCompanyName: '', // 公司名称
          invoiceDepartmentNo: '',
          invoiceDepartmentName: '',
          transactionTypeCode: '', // 事务处理类型(下拉)
          invoiceNum: '', // 单据编号
          invoiceCreatePersonCode: '', // 制单人
          invoiceCreatePersonName: '', // 制单人名称
          invoiceCreateDate: '', // 制单日期
          partnerCode: '', // 客户编码
          partnerName: '', // 客户名称
          currency: '', // 币种
          companyCurrency: '', //公司本位币
          currencyName: '', // 币种名称
          exchangeType: '', // 汇率类型
          exchangeRate: '', // 汇率
          exchangeDate: '', // 汇率日期
          belongDate: '', // 归属日期
          invoiceAmount: 0, // 发票总金额
          excludedTaxAmount: '', // 不含税金额
          taxAmount: '', // 税额
          invoiceType: '', // 发票类型
          invoiceStatus: '', // 单据状态
          invoiceAccountedAmount: '', // 本币总金额
          excludedTaxAccountedAmount: '', // 本币不含税金额
          taxAccountedAmount: '', // 本币税额
          recoverableTaxAmount: '', // 出口退税额
          ladingDifferenceAmount: '', // 与提单/退货单差异金额合计
          performancePeriod: '', //天数
          mark: '', // 备注
          ticketPoint: '', //票点
          expenseTypeCode: '', //费用类型
          // taxRateCode: '',
          chargePersonNo: '', //负责人编码
          businessType: '',
          chargePersonName: '', //负责人名称
          invoiceInfoId: '', // 关联蓝票
          goldenInvoiceNumber: '',
          productType: '', // 商品类型
          businessGroup: '',
        },
        initFlag: true, //查询详情进入页面时，先不执行handleChange
        companyList: [],
        departmentList: [],
        isShowCreditMemo: false, // 红票多显示一个字段
      };
    },
    mounted() {
      this.getCompany();
    },
    methods: {
      getDetail(data) {
        this.formData = {
          ...data,
          invoiceInfoId: data?.invoiceInfoId + '',
          expenseTypeCode: data?.invoiceInfoId ? data?.expenseTypeCode : '01',
          // taxRateCode: data?.invoiceInfoId ? data?.taxRateCode : '108020799',
          productType: data?.invoiceInfoId ? data?.productType : '1',
          invoiceAmount: this.replaceZeroStr(data?.invoiceAmount),
          taxAmount: this.replaceZeroStr(data?.taxAmount),
          excludedTaxAmount: this.replaceZeroStr(data?.excludedTaxAmount),
          invoiceAccountedAmount: this.replaceZeroStr(data?.invoiceAccountedAmount),
          taxAccountedAmount: this.replaceZeroStr(data?.taxAccountedAmount),
          excludedTaxAccountedAmount: this.replaceZeroStr(data?.excludedTaxAccountedAmount),
        };
        // 判断当前是否为红票
        if (data.invoiceType == 'creditMemo') {
          this.isShowCreditMemo = true;
        } else {
          this.isShowCreditMemo = false;
        }
        this.initFlag = true;
        this.getdepartmentList(this.formData.invoiceCompanyCode);
        this.$nextTick(() => {
          this.initFlag = false;
        });
      },

      handleChange(v, prop) {
        console.log(v, prop, '切换', v[prop]);
        if (this.canEdit && !this.initFlag) {
          this.formData[prop] = v[prop];
          if (prop == 'invoiceCompanyCode') {
            this.formData.partnerCode = '';
            this.formData.partnerName = '';
            this.formData.invoiceDepartmentNo = '';
            this.formData.invoiceDepartmentName = '';
            this.formData.invoiceCompanyCode = v[prop];
            this.formData.invoiceCompanyName = v[prop]
              ? this.companyList.find((it) => it.value == v[prop]).label
              : '';
            if (this.formData.invoiceSource !== '3') return;
            this.selectCompanyCurrency(this.formData.invoiceCompanyCode);
            // 公司变更 行信息中部门失效 所以要清空行信息
            this.$emit('resetRowInfo');
            if (!v[prop]) {
              this.departmentList = null;
              return;
            }
            this.getdepartmentList(this.formData.invoiceCompanyCode);
          } else if (prop == 'currency') {
            this.formData.currencyName =
              this.currencyList.find((i) => i.value === v[prop]) &&
              (this.currencyList.find((i) => i.value === v[prop]).label || '');
            if (['1', '2'].includes(this.formData.invoiceSource)) return;
            this.selectTaxRate();
          } else if (prop == 'exchangeDate' || prop == 'exchangeType') {
            this.selectTaxRate();
          } else if (prop == 'partnerCode') {
            console.log(v[prop]);
            if (v[prop]) {
              let info = v[prop][0];
              this.formData.partnerName = info.partnerZhName;
              this.formData.partnerCode = info.partnerCode;
              this.formData.creditCode = info.creditCode;
              this.formData.partnerAddress = info.invoiceAddress;
              this.$emit('setRateInfo', info);
            } else {
              this.formData.partnerName = '';
            }
          } else if (prop == 'belongDate') {
            if (!this.formData.goldenTaxDate)
              this.formData.goldenTaxDate = this.formData.belongDate;
          } else if (prop == 'invoiceDepartmentNo') {
            this.formData.invoiceDepartmentNo = v[prop];
            this.formData.invoiceDepartmentName = v[prop]
              ? this.departmentList.find((it) => it.value == v[prop]).label
              : '';
            this.$emit('resetRowInfo');
          } else if (prop == 'invoiceType') {
            if (v[prop] == 'creditMemo') {
              // 红票的时候显示扩展项
              this.isShowCreditMemo = true;
            } else {
              this.isShowCreditMemo = false;
            }
            this.$emit('resetRowInfo');
          } else if (prop == 'invoiceInfoId') {
            // 选择蓝票
            let info = v[prop][0];
            this.formData.invoiceInfoId = info['id'];
            this.formData.goldenInvoiceNumber = info['goldenInvoiceNumber'];
          } else if (prop == 'redCause') {
            this.formData.redCause = v[prop];
            this.formData.redCauseName = this.dictListMap?.redCauseList?.find(
              (item) => item.value == v[prop]
            )?.label;
          } else if (prop == 'businessType') {
            this.$emit('changeBusinessTypeHandler', v[prop]);
          }
        }
      },

      //获取公司信息
      async getCompany() {
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
        };
        const selectStatus = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          let personCompanyInfo = selectStatus.data.data.personCompanyInfo || [];
          if (personCompanyInfo[0]) {
            this.companyList = personCompanyInfo.map((it) => {
              return { value: it.personCompanyCode, label: it.personCompanyName };
            });
          }
        }
      },
      // 获取部门
      async getdepartmentList(companyCode) {
        // TODO 公司代码字段未定
        this.departmentList = [];
        let params = {
          id: this.userInfo.userCode,
          userCode: this.userInfo.userCode,
          personName: this.userInfo.userName,
          personCompanyCode: companyCode,
        };
        const selectStatus = await this.$axios.post(BASE_API.GET_PERSON_API, params);
        if (selectStatus.data.code == 0) {
          let personDepartmentInfo = selectStatus.data.data.personDepartmentInfo || [];
          if (personDepartmentInfo[0]) {
            this.departmentList = personDepartmentInfo.map((it) => {
              return { value: it.personDepartmentCode, label: it.personDepartmentName };
            });
          }
        }
      },
      // 获取公司对应本币位
      selectCompanyCurrency(companyCode) {
        this.$baseRequest.getLedger(companyCode).then((res) => {
          if (res.length > 0) {
            //默认账套
            this.formData.ledgerCode = res[0].ledgerCode;
            //默认汇率类型
            this.formData.exchangeType = res[0].defaultExchangeType;
            this.formData.currency = res[0].currencyCode;
            this.formData.companyCurrency = res[0].currencyCode;
            this.selectTaxRate();
          } else {
            //没有查询到公司账套
            this.formData.exchangeType = null;
            this.formData.exchangeRate = null;
            this.$alert(this.$t('addInvoice.warnInfo.ledgerInfo'));
          }
        });
      },
      //获取汇率
      getRate() {
        if (this.formData.currency || this.formData.companyCurrency) {
          // const { tenantCode, companyCode, departmentCode } = this.userInfo;
          const params = {
            fromCurrencyCode: this.formData.currency,
            toCurrencyCode: this.formData.companyCurrency,
            exchangeDate: this.$baseRequest.getBeginOfMonth(this.formData.exchangeDate),
            exchangeType: this.formData.exchangeType,
          };
          this.$baseRequest.getRate(params).then((res) => {
            if (res) {
              this.formData.exchangeRate = res.positiveRate;
            } else {
              this.formData.exchangeRate = null;
              this.$message({ showClose: true, message: '缺少对应汇率，请维护', type: 'error' });
            }
          });
        }
      },
      // 千分位
      toLocaleString(num) {
        return num && num.toLocaleString();
      },
      // 汇率值获取
      selectTaxRate() {
        // let taxRate;
        if (
          this.formData.companyCurrency &&
          this.formData.currency &&
          this.formData.companyCurrency === this.formData.currency
        ) {
          // this.feeInfo.exchangeType = 'User'
          this.formData.exchangeRate = 1;
        } else if (this.formData.companyCurrency && this.formData.currency) {
          this.getRate();
        }
      },
      // 获取默认对账科目
      getPayableAccount(partnerCode) {
        const params = {
          partnerCode,
        };
        this.$axios.get(API.GET_PROCUREMENT_RECONCILATION_SUBJECT, params).then((res) => {
          if (0 == res.data.code) {
            this.$set(
              this.feeInfo,
              'payableAccount',
              res.data.data.procurementReconciliationSubject || null
            );
          }
        });
      },
      // 校验
      getVal() {
        return new Promise((resolve) => {
          this.$refs.topData
            .handleSubmit()
            .then(() => {
              resolve(true);
            })
            .catch(() => {
              resolve(false);
            });
        });
      },
    },
  };
</script>
<style lang="scss" scoped>
  .rate .el-form-item__content {
    display: flex;
  }
</style>
